import React from "react";
import Pulkit from "./img/pulkit.jpg";
import Akash from "./img/akash.jpg";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import FacebookIcon from "@material-ui/icons/Facebook";
import YouTubeIcon from "@material-ui/icons/YouTube";
import InstagramIcon from "@material-ui/icons/Instagram";

import "./css/family.css";

function Family() {
  return (
    <div className="courses">
      <div className="courses-content span">
        <p>Who we are</p>
      </div>
      <div className="courses-content-cards">
        <div className="courses-cards">
          <div className="courses-card">
            <div className="courses-card-img border">
              <img className="img" src={Akash} alt="coding" />
            </div>
            <div className="courses-desc">
              <div className="courses-desc-content">
                <p>Akash Kumar Verma</p>
                <div className="courses-desc-content-curri">
                  <p>SDE 1 | Passionate Programmer | Youtuber</p>
                </div>
                <div className="footer-strips">
                  <div className="footer-strip-social">
                    <TwitterIcon />
                  </div>
                  <div className="footer-strip-social">
                    <FacebookIcon />
                  </div>
                  <div className="footer-strip-social">
                    <InstagramIcon />
                  </div>
                  <div className="footer-strip-social">
                    <YouTubeIcon />
                  </div>
                  <div className="footer-strip-social">
                    <LinkedInIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="courses-card skills">
            <div className="courses-card-img border">
              <img className="img" src={Pulkit} alt="skills" />
            </div>
            <div
              style={{
                marginRight: "auto",
                marginLeft: 0,
              }}
              className="courses-desc"
            >
              <div className="courses-desc-content">
                <p>Pulkit Sharma</p>
                <div className="courses-desc-content-curri">
                  <p>Digital Marketing Specialist | Life Coach</p>
                </div>
                <div className="footer-strips">
                  <div className="footer-strip-social">
                    <TwitterIcon />
                  </div>
                  <div className="footer-strip-social">
                    <FacebookIcon />
                  </div>
                  <div className="footer-strip-social">
                    <InstagramIcon />
                  </div>
                  <div className="footer-strip-social">
                    <YouTubeIcon />
                  </div>
                  <div className="footer-strip-social">
                    <LinkedInIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Family;
